module.exports = __webpack_public_path__ + "img/COM-i-2-III.0eb8bed6.png";